import api from '../api';

export default {
  namespaced: true,
  state: {
    listUsers: {
      beanList: [],
      total: 0,
    },
  },
  mutations: {
    setStateListUsers(state, info) {
      state.listUsers = info;
    },
  },
  actions: {
    getListUsers({ commit }, params) {
      return api.post('/authUsers/listUsers', '列出用户列表', params).then((res) => {
        commit('setStateListUsers', res);
      });
    },
    createUser(store, params) {
      return api.post('/authUsers/create', '创建用户', params);
    },
    updateUser(store, params) {
      return api.post('/authUsers/updateBaseInfo', '修改用户基本信息', params);
    },
    deleteUser(store, params) {
      return api.post('/authUsers/deleteUser', '删除账号', params);
    },
    disableUser(store, params) {
      return api.post('/authUsers/disableUser', '停用账号', params);
    },
    enableUser(store, params) {
      return api.post('/authUsers/enableUser', '启用账号', params);
    },
    hasDisableAncestor(store, params) {
      return api.post('/authUsers/hasDisableAncestor', '是否有父账号未启用', params);
    },
    getPermissions(store, params) {
      return api.post('/authUsers/listSystemPermissions', '列出用户权限', params);
    },
    updatePermissions(store, params) {
      return api.post('/authUsers/updatePermissions', '编辑用户权限', params);
    },
    updatePassword(store, params) {
      return api.post('/authUsers/updatePassword', '修改当前登录的用户密码', params);
    },
    updateGoogleFreeze(store, params) {
      return api.post('/authUsers/freezeUser', '更新谷歌验证冻结状态', params);
    },
    // 验证谷歌验证码
    verifyGoogleCode(store, params) {
      return api
        .get(`/google/authenticator/verify/${params.code}`, '验证谷歌验证码')
        .then((res) => {
          return res;
        });
    },
  },
};
